import { useModel } from "@bcm-dev/bcms-vite";

import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';

import "./styles.css";

export default function CH21Page(props) {
    const branding = useModel().branding.options;
    window.BRANDING = { "cards_abi22": branding.cards_abi22 };
    // In MABI23, CH21 is shown without an ABI22 container. 
    // It appears as a standalone app.
    const removeABI22Container = props.removeAB22IContainer ? props.removeAB22IContainer : false;

    const mabiBranding = window.mabi23Branding;
    const option = mabiBranding
      ? mabiBranding.options.integrated_page_header_mabi23
      : branding.integrated_page_header_abi22;
    const showHeader = option !== "false";

    return (
        <>
            { !removeABI22Container &&
            <PageContainer className="cardhub-mobile-page integrated-product-page" ignoreTrigger={ true }>
                <PageContentView>
                    <CenterContentContainer>
                        { showHeader && <ContentHeaderView text="Cards" /> }

                        <ExternalIframe demo="CH21" key ="CH21Page"/>
                    </CenterContentContainer>
                </PageContentView>
            </PageContainer>
            }
            { removeABI22Container && <ExternalIframe demo="CH21" className="cardhub-mobile-iframe" key ="CH21Page"/> }
        </>
    );
}
